import html2canvas from "html2canvas";

/** A4 page size at 96 DPI (standard screen reference). */
export const A4_WIDTH_PX = 794;
export const A4_HEIGHT_PX = 1123;
export const A4_PADDING_PX = 48;

/**
 * Captures an invoice DOM node as a fixed A4-sized PNG, independent of the
 * viewport width used for on-screen preview (e.g. mobile).
 */
export async function captureInvoiceImage(
  sourceElement: HTMLElement,
  filename: string,
): Promise<void> {
  const container = document.createElement("div");
  container.setAttribute("aria-hidden", "true");
  container.style.cssText = [
    "position: fixed",
    "left: -10000px",
    "top: 0",
    `width: ${A4_WIDTH_PX}px`,
    `min-height: ${A4_HEIGHT_PX}px`,
    "background: #ffffff",
    `padding: ${A4_PADDING_PX}px`,
    "box-sizing: border-box",
    "overflow: visible",
  ].join(";");

  const clone = sourceElement.cloneNode(true) as HTMLElement;
  clone.style.cssText = [
    "width: 100%",
    "max-width: none",
    "min-width: 0",
    "margin: 0",
    "box-shadow: none",
    "border-radius: 0",
  ].join(";");

  container.appendChild(clone);
  document.body.appendChild(container);

  try {
    await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));

    const contentHeight = Math.max(A4_HEIGHT_PX, container.scrollHeight);

    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
      width: A4_WIDTH_PX,
      height: contentHeight,
      windowWidth: A4_WIDTH_PX,
      windowHeight: contentHeight,
    });

    const link = document.createElement("a");
    link.download = filename.endsWith(".png") ? filename : `${filename}.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
  } finally {
    document.body.removeChild(container);
  }
}
